export const TOAST_MESSAGES = {
  success: {
    login: "Login successful!",
    forgotPassword: "Password reset link sent to your email",
    resetPassword: "Password reset successfully",
    changePassword: "Password updated successfully",
  },
  error: {
    loginInvalid: "Invalid email or password",
    loginFailed: "An error occurred during login",
    forgotPasswordFailed: "Failed to send reset link",
    resetPasswordFailed: "Failed to reset password",
    changePasswordFailed: "Failed to update password",
  },
} as const;

export const VALIDATION_MESSAGES = {
  email: {
    required: "Email is required",
    invalid: "Enter a valid email address",
  },
  password: {
    required: "Password is required",
    minLength: "Password must be at least 8 characters",
    invalid: "Password must contain uppercase, lowercase, number and special character",
  },
  confirmPassword: {
    required: "Please confirm your password",
    mismatch: "Passwords do not match",
  },
} as const;
